import { QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import { isSessionExpiredError } from '@/lib/axios/use-private-request';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Catalog/dashboard data here doesn't change minute-to-minute, so a
      // background refetch every time the user tabs back is mostly noise.
      refetchOnWindowFocus: false,
      // Default to refetch-on-mount for dashboard freshness; the three public
      // catalog hooks in src/hooks/useAgents.ts opt out so they hydrate
      // instantly from sessionStorage without a network round-trip.
      refetchOnMount: true,
      // Don't retry on session expired errors - user needs to re-authenticate
      retry: (failureCount, error) => {
        if (isSessionExpiredError(error)) {
          return false;
        }
        if (isAxiosError(error)) {
          if (error.code === 'ERR_CANCELED') return false;
          if (
            error.config?.method &&
            error.config.method.toLowerCase() !== 'get'
          )
            return false;
          const status = error.response?.status;
          if (status && status < 500 && status !== 408 && status !== 429)
            return false;
        }
        return failureCount < 3;
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
      networkMode: 'always',
    },
    mutations: {
      retry: false,
    },
  },
});
